import { RouteObject, useRoutes } from 'react-router';

type TRouteObject = RouteObject & {
  title?: string;
  path?: string;
  children?: TRouteObject[];
};

export const useAppRoutes = (routesObj: TRouteObject[]) => {
  const processRoutes = (routes: TRouteObject[]): RouteObject[] => {
    return routes.map((routeObj) => {
      const { path, element, children } = routeObj;

      const processedRoute: RouteObject = {
        path,
        element,
      };

      if (children) {
        processedRoute.children = processRoutes(children);
      }

      return processedRoute;
    });
  };

  return useRoutes(processRoutes(routesObj));
};
